import type { UserProfile } from '../services/firestore';

/**
 * Merchants who complete the Shopify App Store install wizard skip legacy address/branding gates.
 * Legacy `industry === 'Shopify Store'` accounts remain supported.
 */
export function shouldSkipShopifyComplianceOnboarding(profile: UserProfile | null): boolean {
  if (!profile) return false;
  return (
    profile.shopifyInstallWizardCompleted === true ||
    profile.acquisitionChannel === 'shopify_app_store' ||
    profile.billingSource === 'shopify' ||
    profile.industry === 'Shopify Store'
  );
}

/** Resume Privy-style install wizard if not finished. */
export function needsShopifyInstallWizard(profile: UserProfile | null): boolean {
  if (!profile) return false;
  if (profile.shopifyInstallWizardCompleted) return false;
  return profile.billingSource === 'shopify' || profile.acquisitionChannel === 'shopify_app_store';
}

/** True when address/sync/branding onboarding must finish before workspace/app use. */
export function requiresShopifyComplianceOnboarding(
  profile: UserProfile | null,
  isShopifyEmbedded: boolean
): boolean {
  if (!profile || shouldSkipShopifyComplianceOnboarding(profile)) return false;
  const shopifyLinked = !!profile.shopifyStore || isShopifyEmbedded || profile.industry === 'Shopify Store';
  if (!shopifyLinked) return false;
  return (
    !profile.addressCompleted ||
    !profile.syncCompleted ||
    !profile.brandingCompleted
  );
}
